import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentJpkSwIsNotObligatoryWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.sale.validation.document-jpk-sw-is-not-obligatory');
    }
}
